import type {ProductRecurrence} from '@/ts/types/dto/user-dto';

/** i18n keys and icon for a subscription plan, derived from its billing interval. */
export interface PlanDisplay {
  /** Title i18n key, or null to fall back to the product's own name. */
  titleKey: string | null;
  /** Description i18n key, or null to fall back to the product's own description. */
  descriptionKey: string | null;
  /** Period-suffix i18n key (e.g. "/ month"), or null for one-time / unknown intervals. */
  periodKey: string | null;
  /** Illustration asset name for the plan card. */
  icon: string;
}

/**
 * Maps a product's billing recurrence to its display keys and icon. Returns null keys for a
 * missing or non-month/year interval so callers fall back to the product's own name/description
 * (never a hardcoded "Monthly").
 */
export function planDisplay(recurring: ProductRecurrence | null | undefined): PlanDisplay {
  if (recurring?.interval === 'year') {
    return {titleKey: 'yearly', descriptionKey: 'yearly_plan_description', periodKey: 'per_year', icon: 'plan-annual.svg'};
  }
  if (recurring?.interval === 'month') {
    return {titleKey: 'monthly', descriptionKey: 'monthly_plan_description', periodKey: 'per_month', icon: 'plan-sun.svg'};
  }
  return {titleKey: null, descriptionKey: null, periodKey: null, icon: 'plan-sun.svg'};
}
